var _ = require('underscore/underscore');

var Base = require('front/components/Base/Base');

module.exports = Base.extend({
    $parent: function () {
        return this.parent.$content;
    },

    setTitle: function (title) {
        title = title || this.title;
        if (title !== undefined) {
            document.title = 'Frequency' + (title ? $('<div> • ' + title + '</div>').text() : '');
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/Section/SubSection.js
// module id = 20
// module chunks = 0